export default __webpack_public_path__ + "static/media/download.27f34dba.gif";